import {
  US_WAITLIST_AUDIENCE_PARAM,
  US_WAITLIST_PATH,
  US_WAITLIST_SELLER_AUDIENCE,
  US_WAITLIST_SELLER_SOURCE_PREFIX,
  US_WAITLIST_SOURCE_PARAM,
} from "@/features/waitlist/us-waitlist.static";
import { isUsLocale } from "@/i18n/config";

/**
 * WHO-6511. Selling from the US is closed (the gateway refuses a US seller, WHO-6501), so on
 * `/en-us` every sell button leads to the waiting list's seller page instead of the create-ad
 * flow. Each button names itself, and the name becomes the signup's source (`sell_header`), so
 * the register shows which button US sellers press.
 *
 * Links built elsewhere (Strapi menus, an old bookmark, a typed URL) are caught by the
 * `/en-us/create-ad` redirect in `config/redirects.js`, with source `sell_direct`.
 */
export type SellEntry =
  | "header"
  | "mobile_menu"
  | "home"
  | "my_ads"
  | "dashboard"
  | "account_menu"
  | "how_it_works"
  | "sellers_landing"
  | "photo_tips"
  | "b2b"
  | "chat"
  | "value_check"
  | "brand_story"
  | "collaboration";

export const usSellerWaitlistHref = (entry: SellEntry | "direct"): string => {
  const params = new URLSearchParams({
    [US_WAITLIST_AUDIENCE_PARAM]: US_WAITLIST_SELLER_AUDIENCE,
    [US_WAITLIST_SOURCE_PARAM]: `${US_WAITLIST_SELLER_SOURCE_PREFIX}_${entry}`,
  });

  return `${US_WAITLIST_PATH}?${params.toString()}`;
};

/**
 * Where a sell button leads in `locale`: its own create-ad route, or the US seller waiting list.
 * `/en-us` is only routed while `US_LAUNCH_ENABLED` is on, so with it off nothing changes.
 */
export const sellRoute = (
  locale: string | undefined,
  entry: SellEntry,
  route: string
): string => (isUsLocale(locale) ? usSellerWaitlistHref(entry) : route);
